module.exports = __webpack_public_path__ + "static/media/interface.fcda5d65.svg";